import {BaseApiModel} from "../../../infrastructure/models/base-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {CompetitorCompetitionsApiModel} from "../../common/competitor/models/competitor-competitions.api-model";

export class CompetitorsResponseApiModel extends BaseApiModel {
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorCompetitionsApiModel>;

  constructor(model: CompetitorsResponseApiModel) {

    super(model);
    this.countries = model.countries;
    this.sports = model.sports;
    this.competitions = model.competitions;
    this.competitors = model.competitors;
  }
}
